import {
  exists,
  NewArrivalNoticeGenre,
  NewArrivalNoticeGenreFromJSON,
  NewArrivalNoticeKeyword,
  NewArrivalNoticeKeywordFromJSON,
  NewArrivalNoticeMagazine,
  NewArrivalNoticeMagazineFromJSON
} from '@/api'

export interface NewArrivalNotice {
  genres: NewArrivalNoticeGenre[]
  keywords: NewArrivalNoticeKeyword[]
  magazines: NewArrivalNoticeMagazine[]
}

export const defaultNewArrivalNotice = (): NewArrivalNotice => ({
  genres: [],
  keywords: [],
  magazines: []
})

export function NewArrivalNoticeFromJSON(json: any): NewArrivalNotice {
  return {
    genres: exists(json, 'genres')
      ? json.genres.map(NewArrivalNoticeGenreFromJSON)
      : [],
    keywords: exists(json, 'keywords')
      ? json.keywords.map(NewArrivalNoticeKeywordFromJSON)
      : [],
    magazines: exists(json, 'magazines')
      ? json.magazines.map(NewArrivalNoticeMagazineFromJSON)
      : []
  }
}
